import { forwardRef, Th, Tr } from "@chakra-ui/react";

export const ScenarioHeaderRow = forwardRef(
  ({ includeSituationDetails = false }, ref) => (
    <Tr ref={ref}>
      <Th>Naam</Th>
      {includeSituationDetails && (
        <>
          <Th>Woningtype</Th>
          <Th>Situering</Th>
        </>
      )}
      <Th>Status</Th>
      <Th>Acties</Th>
    </Tr>
  ),
);
